import React, { useEffect, useRef, useState } from 'react';
import PropTypes from 'prop-types';
import AccessibleTooltip from '../components/common/AccessibleTooltip';

let badgeCount = 0;

/*
A status badge and its explanation. Outside a control the badge is a tab stop that shows the
explanation as a tooltip and carries it as its description. Inside a tile, which is itself a
button, it cannot be a tab stop; the same badge and explanation are in the tile's detail dialog.
The tooltip targets the element itself, so badges need no ids and the same content shown twice
(tile and dialog) no longer repeats one.
*/
const TypesBadge = ({ details }) => {
  const { className, text, tooltip } = details;
  const badgeRef = useRef(null);
  const [descriptionId] = useState(() => 'badge-description-' + (badgeCount += 1));
  const [isInsideControl, setIsInsideControl] = useState(true);

  useEffect(() => {
    setIsInsideControl(Boolean(badgeRef.current.closest('button, a, [role="button"]')));
  }, []);

  const isFocusable = Boolean(tooltip) && !isInsideControl;

  return (
    <>
      <span
        ref={badgeRef}
        className={'badge fs-0 badge-soft-' + className}
        tabIndex={isFocusable ? 0 : undefined}
        aria-describedby={isFocusable ? descriptionId : undefined}
      >
        {text}
      </span>
      {isFocusable && (
        <span id={descriptionId} hidden>
          {tooltip}
        </span>
      )}
      {tooltip && <AccessibleTooltip target={badgeRef}>{tooltip}</AccessibleTooltip>}
    </>
  );
};

TypesBadge.propTypes = {
  details: PropTypes.object.isRequired
};

export default TypesBadge;
